import { ISelectDumbbellWeight, IWizardStep } from 'fitbeat.gym-core';
import React from 'react';
import { StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { Equipment } from '../../../models/src';
import theme from '../theme';
import { answerStrenghtAssessment } from './actions';
import { SelectWeight } from './SelectWeight';

interface IDispatchProps {
  selectWeight(
    index: number,
    currentStep: IWizardStep<ISelectDumbbellWeight>,
  ): void;
}
interface IOwnProps {
  currentStep: IWizardStep<ISelectDumbbellWeight>;
}

type IProps = IDispatchProps & IOwnProps;

export const SelectDumbbellWeightComponent: React.FunctionComponent<IProps> = ({
  currentStep,
  selectWeight,
}) => {
  return (
    <SelectWeight
      weightOptionContainerStyle={styles.weightOptionContainerStyle}
      selectWeight={selectWeight}
      getWeightAndColor={(equipmentWeight)=> {
        return {weight: equipmentWeight};
      }}
      weigthTextStyle={styles.weigthTextStyle}
      currentStep={currentStep}
      isSelected={(index: number, equipmentWeightChosenByUser: number) => {
        const weightAsString = `${equipmentWeightChosenByUser}kg`;
        const indexOfEquipment = currentStep.config.weightOptions.findIndex((weight)=> weight === weightAsString);
        return index === indexOfEquipment;
      }}
    />
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    selectWeight: (index: number, currentStep: IWizardStep<ISelectDumbbellWeight>) => {
      const weightAsString = currentStep.config.weightOptions[index];
      const weight = Number(weightAsString.replace('kg',''));
      dispatch(answerStrenghtAssessment(weight, currentStep, Equipment.Dumbbells));
    },
  };
};

export const SelectDumbbellWeight: React.FC<IOwnProps> = connect(
  null,
  mapDispatchToProps,
)(SelectDumbbellWeightComponent);

const styles = StyleSheet.create({
  weigthTextStyle: {
    color: theme.BLACK,
    letterSpacing: 2,
  },
  weightOptionContainerStyle: {
    alignItems: 'flex-start',
  },
});
